import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import { IconModule } from '../icon/icon.module';



@NgModule({
  declarations: [ModalComponent],
  imports: [
    CommonModule,
    UtilitiesModule,
    IconModule
  ],
  exports: [ModalComponent]
})
export class ModalModule { }
